// extracted by mini-css-extract-plugin
export var component = "TeaserLink-module--component--Bj9EU";
export var inert = "TeaserLink-module--inert--qXVDQ";